export { default } from "./DatabaseStatusSmall";
